import querystring from 'querystring';

import { ProductTypeStatsResponse, StatsResponse } from '../interfaces/Stats';
import Client from './client';

class StatsApi {
  private static classInstance?: StatsApi;

  public static get instance() {
    if (!this.classInstance) {
      this.classInstance = new StatsApi();
    }
    return this.classInstance;
  }

  public stats(queryParam: any): Promise<StatsResponse> {
    return Client.get(`/stats?${querystring.stringify(queryParam)}`);
  }

  public userStats(username: string, queryParam: any): Promise<StatsResponse> {
    return Client.get(
      `/stats/${username}?${querystring.stringify(queryParam)}`
    );
  }

  public productTypeStats(
    queryParam: Record<string, any>
  ): Promise<ProductTypeStatsResponse> {
    return Client.get(
      `/stats/product-types?${querystring.stringify(queryParam)}`
    );
  }

  public userProductTypeStats(
    username: string,
    queryParam: Record<string, any>
  ): Promise<ProductTypeStatsResponse> {
    return Client.get(
      `/stats/product-types/${encodeURIComponent(
        username
      )}?${querystring.stringify(queryParam)}`
    );
  }
}

export default StatsApi.instance;
